import React from 'react';
import PropTypes from 'prop-types';
import { TableHead, TableRow, TableCell, Typography, makeStyles, Hidden, TableSortLabel } from "@material-ui/core";
import t from "../../../languages/pl";
import { themeTypeToBool } from './../../../utils/helpers';
import { TooltipTop } from "../../Common/CustomTooltips";

import { carsOrderEnum } from '../../../utils/enums/carsTableOrderEnum.js'

const useStyles = makeStyles(theme => ({
  header: {
    background: themeTypeToBool(theme.palette.type) ? theme.palette.background.default : theme.palette.background.paper,
  },
  cell: {
    textAlign: "center",
    padding: theme.spacing(1),
  },
  pointer: {
    cursor: "pointer"
  },
  sortIcon: {
    color: (themeTypeToBool(theme.palette.type) ? "#000" : "#FAFAFA") + "!important"
  },
  disabledSortIcon: {
    color: (themeTypeToBool(theme.palette.type) ? "#D3D3D3" : "#808080") + "!important"
  }
}));

const CarDetailsHeader = props => {
  const defaultStyles = useStyles();
  const {
    classes = defaultStyles,
    activeSort,
    order,
    onSortOrderChange,
    meterReadingOrder,
    onSortMeterReadingOrderChange,
    registrationNoOrder,
    onSortRegistrationNoOrderChange
  } = props;

  return (
    <TableHead className={classes.header}>
      <TableRow>
        <TableCell className={classes.cell}>
          <TableSortLabel
            active
            direction={registrationNoOrder}
            onClick={onSortRegistrationNoOrderChange}
            classes={{ icon: activeSort === carsOrderEnum.registrationNoOrder ? classes.sortIcon : classes.disabledSortIcon }}
          >
            <Typography variant="body1">
              {t.registrationNo}
            </Typography>
          </TableSortLabel>
        </TableCell>
        <TableCell className={classes.cell}>
          <Typography variant="body1">
            {t.brand}
          </Typography>
        </TableCell>
        <TableCell className={classes.cell}>
          <Typography variant="body1">
            {t.model}
          </Typography>
        </TableCell>
        <TableCell className={classes.cell}>
          <Typography variant="body1">
            {t.description}
          </Typography>
        </TableCell>
        <TableCell className={classes.cell} sortDirection={order}>
          <TableSortLabel
            active
            direction={order}
            onClick={onSortOrderChange}
            classes={{ icon: activeSort === carsOrderEnum.ecoOrder ? classes.sortIcon : classes.disabledSortIcon }}
          >
            <Typography variant="body1">
              ECO
            </Typography>
          </TableSortLabel>
        </TableCell>
        <TableCell className={classes.cell}>
          <Typography variant="body1">
            { t.fuelLevel } / { t.battery }
          </Typography>
        </TableCell>
        <Hidden mdDown>
          <TableCell className={classes.cell}>
            <Typography variant="body1">
              {t.batteryCondition}
            </Typography>
          </TableCell>
          <TableCell className={classes.cell}>
            <TableSortLabel
              active
              direction={meterReadingOrder}
              onClick={onSortMeterReadingOrderChange}
              classes={{ icon: activeSort === carsOrderEnum.meterReadingOrder ? classes.sortIcon : classes.disabledSortIcon }}
            >
              <Typography variant="body1">
                {t.meterReading}
              </Typography>
            </TableSortLabel>
          </TableCell>
          <TableCell className={classes.cell}>
            <Typography variant="body1">
              {t.serviceCarMode}
            </Typography>
          </TableCell>
          <TableCell className={classes.cell}>
            <Typography variant="body1">
              {t.gprs}
            </Typography>
          </TableCell>
          <TableCell className={classes.cell}>
            <Typography variant="body1">
              {t.poi}
            </Typography>
          </TableCell>
          <TableCell className={classes.cell}>
            <Typography variant="body1">
              {t.state}
            </Typography>
          </TableCell>
        </Hidden>
        <TableCell/>
      </TableRow>
    </TableHead>
  );
};

export default CarDetailsHeader;

CarDetailsHeader.propTypes = {
  classes: PropTypes.object,
  order: PropTypes.string,
  onSortOrderChange: PropTypes.func,
  meterReadingOrder: PropTypes.string,
  onSortMeterReadingOrderChange: PropTypes.func,
  registrationNoOrder: PropTypes.string,
  onSortRegistrationNoOrderChange: PropTypes.func,
  activeSort: PropTypes.number
};
